/**
 * Survey.js schema for session feedback modal
 * Comprehensive feedback collection for user sessions
 */

export const feedbackSurveySchema = {
  title: "Session Feedback",
  description: "Help us improve your experience in 30-60 seconds",
  showProgressBar: "bottom",
  progressBarType: "pages",
  showQuestionNumbers: "off",
  showPrevButton: false,
  showNextButton: false,
  autoAdvanceEnabled: true,
  completeText: "Send Feedback",
  pages: [
    {
      name: "overall_experience",
      title: "Overall Experience",
      elements: [
        {
          type: "rating",
          name: "overall_satisfaction",
          title: "How satisfied are you with your session today?",
          isRequired: true,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "Unhappy",
          maxRateDescription: "Happy"
        },
        {
          type: "rating",
          name: "productivity",
          title: "How productive was this session?",
          isRequired: true,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "Barely",
          maxRateDescription: "Very"
        },
        {
          type: "rating",
          name: "ease_of_use",
          title: "How easy was it to complete your tasks?",
          isRequired: true,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "Hard",
          maxRateDescription: "Easy"
        }
      ]
    },
    {
      name: "specific_aspects",
      title: "Specific Aspects",
      elements: [
        {
          type: "rating",
          name: "ai_quality",
          title: "AI Quality (transcripts, summaries, data extraction)",
          isRequired: false,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "Poor",
          maxRateDescription: "Excellent"
        },
        {
          type: "rating",
          name: "ui_responsiveness",
          title: "UI Responsiveness & Speed",
          isRequired: false,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "Slow",
          maxRateDescription: "Fast"
        },
        {
          type: "rating",
          name: "feature_completeness",
          title: "Feature Completeness",
          isRequired: false,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "Missing",
          maxRateDescription: "Jam packed"
        },
        {
          type: "rating",
          name: "data_accuracy",
          title: "Data Accuracy (patient info, classifications, etc.)",
          isRequired: false,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "Low",
          maxRateDescription: "Great"
        }
      ]
    },
    {
      name: "issues_feedback",
      title: "Issues & Feedback",
      elements: [
        {
          type: "checkbox",
          name: "issues_encountered",
          title: "Did you encounter any of these issues? (check all that apply)",
          choices: [
            { value: "slow_loading", text: "Slow loading times" },
            { value: "incorrect_ai_data", text: "Incorrect AI-extracted data" },
            { value: "ui_bugs", text: "UI bugs or glitches" },
            { value: "missing_features", text: "Missing features I needed" },
            { value: "confusing_workflow", text: "Confusing workflow" },
            { value: "mobile_issues", text: "Mobile/responsive issues" },
            { value: "other", text: "Other (please describe below)" }
          ]
        },
        {
          type: "comment",
          name: "what_went_well",
          title: "What went well today?",
          placeholder: "Tell us what you liked or what worked smoothly...",
          rows: 3
        },
        {
          type: "comment",
          name: "what_needs_improvement",
          title: "What needs improvement?",
          placeholder: "Share any frustrations or areas that could be better...",
          rows: 3
        },
        {
          type: "comment",
          name: "feature_requests",
          title: "Feature requests or suggestions",
          placeholder: "What features would make your work easier?",
          rows: 3
        }
      ]
    }
  ]
};

export default feedbackSurveySchema;